<template>
  <div>
    <OtpScreen
      :otpStatus="{ incorrect: false }"
      :verifyOtp="verifyOtpWithDelay"
      :sendCode="sendCodeWithDelay"
      mobileLastFour="3456"
      class="mb-28"
    />

    <OtpScreen
      ref="codeEntryScreen1"
      :otpStatus="{ incorrect: false }"
      :verifyOtp="verifyOtpWithDelay"
      :sendCode="sendCodeWithDelay"
      mobileLastFour="3456"
      class="mb-28"
    />

    <OtpScreen
      ref="codeEntryScreen2"
      :otpStatus="{ incorrect: true }"
      :verifyOtp="verifyOtpWithDelay"
      :sendCode="sendCodeWithDelay"
      mobileLastFour="3456"
      class="mb-28"
    />

    <OtpScreen
      :otpStatus="{ incorrect: false }"
      :verifyOtp="verifyOtpWithDelay"
      :sendCode="sendCodeWithDelay"
      mobileLastFour="6789"
      :branding="{
        colours: {
          primary: '#f012be',
          primaryIsWhite: false,
          accentPrimary: '#7E10C1',
          accentSecondary: '#ffffff'
        },
        logo: logoWide
      }"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import OtpScreen from '@/components/screens/OtpScreen'
import logoWide from '@/assets/designs/logo-wide.png'

const codeEntryScreen1 = ref(null)
const codeEntryScreen2 = ref(null)

function sendCodeWithDelay () {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, 2000) // 2-second delay
  })
}

function verifyOtpWithDelay (otpCode) {
  console.info('verifyOtp', otpCode)

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, 2000) // 2-second delay
  })
}

onMounted(() => {
  codeEntryScreen1.value.$el.querySelector('.l-BaseButton').click()
  codeEntryScreen2.value.$el.querySelector('.l-BaseButton').click()
})
</script>
